import firebase from "firebase/app";
import "firebase/database";

let config = {
    apiKey: "AIzaSyDoxbuv-3D1bvTUe9o9DplyzxzoeDCC-u0",
    authDomain: "editor-7bae0.firebaseapp.com",
    databaseURL: "https://editor-7bae0-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "editor-7bae0",
    storageBucket: "editor-7bae0.appspot.com",
    messagingSenderId: "727761123854",
    appId: "1:727761123854:web:fe6c3c0c17d4fc05425a5f"
};
firebase.initializeApp(config);

export default firebase.database();
